var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"Новый заказ"}},[_c('order-form',{attrs:{"invoice":_vm.proformaInvoice ? _vm.proformaInvoice.data : null,"sets":_vm.sets.data,"companies":_vm.companies.data,"stages":_vm.stages.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }